<template>
  <b-field
    :label="labelPosition == 'top' ? label : null"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
    :class="{ 'required': required }"
  >
    <b-switch
      :value="value"
      :type="type"
      :size="size"
      :true-value="trueValue"
      :false-value="falseValue"
      :class="{'is-danger': hasError()}"
      @input="inputListener($event)"
    >
      {{ labelPosition == 'right' ? label : null }}
    </b-switch>
  </b-field>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      type: Boolean
    },
    type: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: undefined
    },
    trueValue: {
      type: Boolean,
      default: false
    },
    falseValue: {
      type: Boolean,
      default: false
    },
    labelPosition: {
      type: String,
      default: "top"
    },
    required: {
      type: Boolean,
      default: false
    }
  }
};
</script>
